export default __webpack_public_path__ + "static/media/icon-insights-check.f2a26fcc.svg";